import type { Room } from '@hollowveil/shared';

export const roomNightmareChristmas: Room = {
  id: 'room_nightmare_christmas',
  name: "L'Étrange Noël - Christmas Town",
  description: "La joyeuse ville de Noël avec ses lumières et sa neige. Mais Halloween Town rôde dans l'ombre...",
  size: [24, 10, 24],
  floorStyle: 'snow',
  ambiance: {
    realWorld: {
      // Christmas Town - chaleureux, joyeux, enneigé
      backgroundColor: '#1a3a5a',
      ambientLightColor: '#FFD700',
      ambientLightIntensity: 0.8,
    },
    spectralWorld: {
      // Halloween Town - sombre, orange, effrayant
      backgroundColor: '#0a0a1a',
      ambientLightColor: '#ff6600',
      ambientLightIntensity: 0.25,
      fogColor: '#1a0a2a',
      fogDensity: 0.06,
    },
  },
  objects: [
    // === MONDE RÉEL - CHRISTMAS TOWN ===

    // Grand sapin de Noël central
    {
      id: 'obj_christmas_tree',
      name: 'Sapin de Noël Géant',
      type: 'interactive',
      modelId: 'christmas_tree',
      position: [12, 0, 12],
      rotation: [0, 0, 0],
      scale: [3, 3, 3],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un magnifique sapin décoré de guirlandes lumineuses et de boules colorées !",
          },
        },
      ],
    },

    // Maisons de Noël
    {
      id: 'obj_gingerbread_house_1',
      name: 'Maison en Pain d\'Épices',
      type: 'interactive',
      modelId: 'gingerbread_house',
      position: [4, 0, 6],
      rotation: [0, 0.3, 0],
      scale: [1.8, 1.8, 1.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une adorable maison en pain d'épices. Ça sent le sucre et la cannelle !",
          },
        },
      ],
    },
    {
      id: 'obj_gingerbread_house_2',
      name: 'Maison en Pain d\'Épices',
      type: 'static',
      modelId: 'gingerbread_house',
      position: [8, 0, 4],
      rotation: [0, -0.2, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_christmas_cottage',
      name: 'Chalet de Noël',
      type: 'static',
      modelId: 'christmas_cottage',
      position: [18, 0, 6],
      rotation: [0, 0.5, 0],
      scale: [1.6, 1.6, 1.6],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // Atelier du Père Noël
    {
      id: 'obj_santa_workshop',
      name: 'Atelier du Père Noël',
      type: 'interactive',
      modelId: 'santa_workshop',
      position: [20, 0, 14],
      rotation: [0, -Math.PI / 4, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "L'atelier magique où les lutins fabriquent tous les jouets du monde !",
          },
        },
      ],
    },

    // Lampadaires festifs
    {
      id: 'obj_lamp_1',
      name: 'Lampadaire de Noël',
      type: 'static',
      modelId: 'christmas_lamp',
      position: [6, 0, 10],
      rotation: [0, 0, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_lamp_2',
      name: 'Lampadaire de Noël',
      type: 'static',
      modelId: 'christmas_lamp',
      position: [18, 0, 10],
      rotation: [0, 0, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // Bonhomme de neige
    {
      id: 'obj_snowman',
      name: 'Bonhomme de Neige',
      type: 'interactive',
      modelId: 'snowman',
      position: [8, 0, 16],
      rotation: [0, 0.5, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un joyeux bonhomme de neige avec un chapeau haut-de-forme et une carotte pour nez !",
          },
        },
      ],
    },

    // Cadeaux
    {
      id: 'obj_presents_1',
      name: 'Pile de Cadeaux',
      type: 'static',
      modelId: 'gift_pile',
      position: [10, 0, 13],
      rotation: [0, 0.3, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },
    {
      id: 'obj_presents_2',
      name: 'Pile de Cadeaux',
      type: 'static',
      modelId: 'gift_pile',
      position: [14, 0, 11],
      rotation: [0, -0.4, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
    },

    // Traîneau du Père Noël
    {
      id: 'obj_santa_sleigh',
      name: 'Traîneau du Père Noël',
      type: 'interactive',
      modelId: 'santa_sleigh',
      position: [16, 0, 20],
      rotation: [0, Math.PI / 6, 0],
      scale: [1.8, 1.8, 1.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le traîneau magique qui voyage dans le monde entier en une seule nuit !",
          },
        },
      ],
    },

    // === MONDE SPECTRAL - HALLOWEEN TOWN ===

    // Spiral Hill (colline emblématique)
    {
      id: 'obj_spiral_hill',
      name: 'Colline Spirale',
      type: 'interactive',
      modelId: 'spiral_hill',
      position: [12, 0, 18],
      rotation: [0, 0, 0],
      scale: [2.5, 2.5, 2.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La Colline Spirale... où Jack contemple la lune et rêve de quelque chose de plus.",
          },
        },
      ],
    },

    // Maison de Jack
    {
      id: 'obj_jack_house',
      name: 'Maison de Jack',
      type: 'interactive',
      modelId: 'jack_tower',
      position: [6, 0, 20],
      rotation: [0, 0.3, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La tour tordue de Jack Skellington, le Roi des Citrouilles.",
          },
        },
      ],
    },

    // Citrouilles géantes
    {
      id: 'obj_pumpkin_1',
      name: 'Citrouille Géante',
      type: 'static',
      modelId: 'giant_pumpkin',
      position: [4, 0, 14],
      rotation: [0, 0.5, 0],
      scale: [1.8, 1.8, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_pumpkin_2',
      name: 'Citrouille Sculptée',
      type: 'interactive',
      modelId: 'jack_o_lantern',
      position: [8, 0, 8],
      rotation: [0, -0.3, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une citrouille sculptée qui brille d'une lumière inquiétante...",
          },
        },
      ],
    },
    {
      id: 'obj_pumpkin_3',
      name: 'Citrouille',
      type: 'static',
      modelId: 'giant_pumpkin',
      position: [18, 0, 16],
      rotation: [0, 1.2, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Arbres morts tordus
    {
      id: 'obj_spooky_tree_1',
      name: 'Arbre Tordu',
      type: 'static',
      modelId: 'spooky_tree',
      position: [2, 0, 10],
      rotation: [0, 0.3, 0],
      scale: [2, 2.5, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_spooky_tree_2',
      name: 'Arbre Hanté',
      type: 'static',
      modelId: 'spooky_tree',
      position: [22, 0, 8],
      rotation: [0, -0.5, 0],
      scale: [1.8, 2.2, 1.8],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Fontaine aux serpents
    {
      id: 'obj_snake_fountain',
      name: 'Fontaine aux Serpents',
      type: 'interactive',
      modelId: 'creepy_fountain',
      position: [12, 0, 6],
      rotation: [0, 0, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une fontaine d'où coule un liquide vert et visqueux...",
          },
        },
      ],
    },

    // Guillotine
    {
      id: 'obj_guillotine',
      name: 'Guillotine',
      type: 'interactive',
      modelId: 'guillotine',
      position: [16, 0, 4],
      rotation: [0, Math.PI / 4, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une guillotine décorative... du moins on l'espère.",
          },
        },
      ],
    },

    // Cercueils
    {
      id: 'obj_coffin_1',
      name: 'Cercueil',
      type: 'static',
      modelId: 'coffin',
      position: [20, 0, 2],
      rotation: [0, 0.2, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_coffin_2',
      name: 'Cercueil Ouvert',
      type: 'interactive',
      modelId: 'coffin_open',
      position: [2, 0, 4],
      rotation: [0, -0.3, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un cercueil vide... ou quelqu'un vient d'en sortir ?",
          },
        },
      ],
    },

    // Pierre tombale
    {
      id: 'obj_tombstone_1',
      name: 'Pierre Tombale',
      type: 'static',
      modelId: 'tombstone',
      position: [4, 0, 2],
      rotation: [0, 0.1, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },
    {
      id: 'obj_tombstone_2',
      name: 'Pierre Tombale',
      type: 'static',
      modelId: 'tombstone',
      position: [6, 0, 3],
      rotation: [0, -0.1, 0.05],
      scale: [0.9, 1.1, 0.9],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // Portail des Fêtes
    {
      id: 'obj_holiday_doors',
      name: 'Arbres aux Portes',
      type: 'interactive',
      modelId: 'holiday_tree_doors',
      position: [10, 0, 2],
      rotation: [0, 0, 0],
      scale: [2, 2, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Les arbres aux portes des fêtes... Noël, Pâques, Saint-Valentin... chaque porte mène à un autre monde.",
          },
        },
      ],
    },

    // === OBJETS COLLECTIBLES ===
    {
      id: 'obj_santa_hat',
      name: 'Bonnet du Père Noël',
      type: 'interactive',
      modelId: 'santa_hat',
      position: [19, 0.5, 15],
      rotation: [0.3, 0.5, 0],
      scale: [0.8, 0.8, 0.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'santa_hat',
            itemName: 'Bonnet du Père Noël',
            itemDescription: "Le bonnet rouge et blanc emblématique. Qui sait quelles idées folles il peut inspirer...",
            itemIcon: 'star',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Vous trouvez le bonnet du Père Noël ! Peut-être que Jack l'a laissé tomber...",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_santa_hat' },
        },
      ],
    },

    {
      id: 'obj_soul_robber',
      name: 'Attrape-Âmes',
      type: 'interactive',
      modelId: 'soul_robber',
      position: [6, 0.3, 18],
      rotation: [0, 0.8, 0],
      scale: [0.7, 0.7, 0.7],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'soul_robber',
            itemName: 'Attrape-Âmes',
            itemDescription: "L'arme signature de Jack. Peut prendre n'importe quelle forme.",
            itemIcon: 'scroll',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "L'Attrape-Âmes de Jack ! Un objet qui peut se transformer en ce que vous imaginez.",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_soul_robber' },
        },
      ],
    },
  ],
  puzzles: [],
  connections: [],
  initialWorld: 'real',
  hasSpectralLayer: true,
  palette: 'ice',
  biome: 'ice',
  weather: 'snow',
  weatherIntensity: 0.5,
  npcs: [
    // === MONDE RÉEL - CHRISTMAS TOWN ===
    {
      id: 'npc_santa_claus',
      type: 'santa_claus',
      name: 'Père Noël',
      position: [20, 0, 12],
      scale: 4,
      idleAnimation: 'jolly',
      petAnimation: 'hohoho',
      petRadius: 3,
      petCooldown: 3000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_elf_1',
      type: 'christmas_elf',
      name: 'Lutin Joyeux',
      position: [18, 0, 14],
      scale: 2,
      idleAnimation: 'work',
      petAnimation: 'jingle',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_elf_2',
      type: 'christmas_elf',
      name: 'Lutin Farceur',
      position: [22, 0, 13],
      scale: 2,
      idleAnimation: 'work',
      petAnimation: 'laugh',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_reindeer',
      type: 'reindeer',
      name: 'Rudolphe',
      position: [14, 0, 20],
      scale: 3,
      idleAnimation: 'graze',
      petAnimation: 'nuzzle',
      petRadius: 2.5,
      petCooldown: 2500,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_gingerbread_man',
      type: 'gingerbread_man',
      name: 'Bonhomme Pain d\'Épices',
      position: [6, 0, 5],
      scale: 2.5,
      idleAnimation: 'dance',
      petAnimation: 'wave',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'real',
    },

    // === MONDE SPECTRAL - HALLOWEEN TOWN ===
    {
      id: 'npc_jack_skellington',
      type: 'jack_skellington',
      name: 'Jack Skellington',
      position: [12, 0, 16],
      scale: 4.5,
      idleAnimation: 'dramatic',
      petAnimation: 'bow',
      petRadius: 3,
      petCooldown: 3000,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_sally',
      type: 'sally',
      name: 'Sally',
      position: [8, 0, 18],
      scale: 3.5,
      idleAnimation: 'gentle',
      petAnimation: 'shy_smile',
      petRadius: 2.5,
      petCooldown: 2500,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_zero',
      type: 'ghost_dog',
      name: 'Zéro',
      position: [10, 1, 17],
      scale: 2,
      idleAnimation: 'float',
      petAnimation: 'bark',
      petRadius: 2,
      petCooldown: 1500,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_oogie_boogie',
      type: 'oogie_boogie',
      name: 'Oogie Boogie',
      position: [20, 0, 6],
      rotation: [0, -Math.PI / 3, 0],
      scale: 5,
      idleAnimation: 'menace',
      petAnimation: 'cackle',
      petRadius: 4,
      petCooldown: 8000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_lock',
      type: 'trick_or_treater',
      name: 'Lock',
      position: [16, 0, 8],
      scale: 2,
      idleAnimation: 'mischief',
      petAnimation: 'giggle',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_shock',
      type: 'trick_or_treater',
      name: 'Shock',
      position: [17, 0, 7],
      scale: 2,
      idleAnimation: 'mischief',
      petAnimation: 'cackle',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_barrel',
      type: 'trick_or_treater',
      name: 'Barrel',
      position: [18, 0, 8],
      scale: 2,
      idleAnimation: 'mischief',
      petAnimation: 'laugh',
      petRadius: 2,
      petCooldown: 2000,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_mayor',
      type: 'two_face_mayor',
      name: 'Le Maire',
      position: [4, 0, 16],
      scale: 3,
      idleAnimation: 'spin_head',
      petAnimation: 'panic',
      petRadius: 2.5,
      petCooldown: 3000,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_dr_finkelstein',
      type: 'mad_scientist',
      name: 'Dr. Finkelstein',
      position: [2, 0, 8],
      scale: 3,
      idleAnimation: 'think',
      petAnimation: 'eureka',
      petRadius: 2.5,
      petCooldown: 3500,
      isPettable: true,
      visibleInWorld: 'spectral',
    },
  ],
};
